export const PASSWORDLESS_SIGNUP_CONTENT_KEYS = Object.freeze({
  COMMIT: Object.freeze({
    DEFAULT: 'buttons.poma.continueAsMemberAndPay',
    EXISTING_MEMBER_ACCOUNT_BASED_CTA_V1: 'buttons.poma.payNowAndCreateAccount',
  }),
  DEFAULT: Object.freeze({
    DEFAULT: 'buttons.poma.continueAsMember',
    EXISTING_MEMBER_ACCOUNT_BASED_CTA_V1:
      'buttons.poma.continueAndCreateAccount',
  }),
});
